<h3 translate="MAIN_RESPONSIBLES"></h3>

<div class="main-responsibles-container">
    <ul class="container-flex">
        @for (responsible of mainResponsibles$ | async; track responsible.employeeId) {
            <li>
                <span
                    class="initials"
                    appTitleProvider
                    [ngClass]="{ primary: responsible.primaryContact, secondary: responsible.secondaryContact }"
                >
                    {{ responsible.initials }}
                </span>
                {{ responsible.employeeName }}
            </li>
        }
    </ul>
</div>
